import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../../../store";
import { Loader } from "../../../../components/loader";
import "react-phone-number-input/style.css";
import Select from "react-select";
import "react-select/dist/react-select.css";
import AvatarEditor from "react-avatar-editor";
import "react-rangeslider/lib/index.css";
import { createWooLocationPage, uploadHeroImage, generateLocationPageContentBaseOnOpenAi } from "../../../../actions/locations";
import { BreadCrumb } from "../../../../components/breadcrumb";
import states from "../data/states.json";
import stateData from "../data/data.json";
import config from "../../../../config";

const toolbarConfig = {
  options: ["inline", "list", "link", "history"]
};

const $ = window.$;

const IMAGE_TYPE = {
 webp : "webp",
 png : "png"
};

const LOCATION_TYPE = {
  state : "state",
  city : "city"
};

const initialState = {
  post_title: ``,
  post_content: `We have cutest, most adorable puppies in Accord, NY to make your complete.`,
  loading: false,
  city: "",
  state: "none",
  stateName: null,
  post_url: "",
  post_meta_title: "",
  post_meta_description: "",
  location_all_puppies_title: "",
  location_all_puppies_description: "",
  location_all_puppies_transportation: "",
  location_hero_title_one: "",
  location_hero_title_two: "",
  location_hero_image_description: "",
  location_hero_image_webp: "https://centralparkpuppies.com/wp-content/uploads/2024/02/hero-location-image.webp",
  location_hero_image_png : "https://centralparkpuppies.com/wp-content/uploads/2024/02/hero-location-image.png",
  location_hero_image_alt : "",
  isHeroWebpImageUploading: false,
  isHeroPngImageUploading: false,
  location_quiz_title: "",
  location_quiz_description: "",
  location_review_title: "",
  location_review_description: "",
  location_finance_title: "",
  location_finance_description: "",
  location_delivery_title: "",
  location_delivery_description: "",
  location_health_commitment_title: "",
  location_health_commitment_description: "", 
  location_core_team_title: "",
  location_core_team_description: "",
  location_contact_title: "",
  location_contact_description: "",
  editorState: null,
  step: 1,
  imageFile: null,
  locationStates: states,
  statesArray : [],
  citiesArray : [],
  locationPagePrompt : {},
  isLoadingGeneratedContents : false,
};

class Datamodal extends React.Component {
  constructor(props) {
    super(props);

  }

  state = initialState;

  onEditorStateChange = editorState => this.setState({ editorState });

  newPageCreate = async () => {
    this.setState({ loading: true });
    let form_step_1 = this.state;
    if (form_step_1) {
      this.props.createWooLocationPage(form_step_1);
    }else{
      NotificationManager.warning("Please check input details again.");
      this.setState({ loading: false });
    }
  };

  changeSelectionVal = event => {
    let value = event.target.value;

    this.setState({
      [event.target.name]: value,
    }, function () {
      this.setState({
        post_url: `puppies-for-sale-${this.state.state}-${this.state.city}`,
        post_title: `Puppies for Sale in ${this.state.state} ${this.state.city}`,
        post_content: `Find the best puppies for sale in ${this.state.city} ${this.state.state}.`,
        location_about_breed_title: `About Our ${this.state.breed}`,
        location_all_breed_title_suffix: `See All Our ${this.state.breed} Puppies for Sale in ${this.state.city}`,
        location_promises_and_assurance_sub_title: `What You Get With Your ${this.state.breed} Puppy`,
        location_cities_title: `Cities in ${this.state.state} Where You Can Buy Your New ${this.state.breed} Puppy`,
        location_finance_image_alt: `${this.state.breed} puppies for sale`
      });
    });
  }
  
  changeState = selected =>{     
    if (selected && selected.value !== "none") {      
      this.setState({ state : selected.value, stateName : selected.label });
      states.forEach(state => {
        if (state.value === selected.value) {
          let options = [{ label: "SELECT CITY", value: null }];
          state.cities.map(city => {
            options.push({ label: city, value: city });
          });     
          this.setState({ citiesArray: options });
        }
      });    
      let locationPrompt = stateData.find(state => state.name == selected.label);
      if(locationPrompt){      
       this.setState({ locationPagePrompt : locationPrompt});
      }   
      this.createDynamicData('state',selected.value);
    }else{
      this.setState({ citiesArray : [] });
    } 
  }

  changeCity = selected => {
    if(selected && selected.value){
      let city = selected.value; 
      this.setState({ city : selected.value });
      let lowerCaseCity =  selected.value.toLowerCase();
      let cityNoSpace = lowerCaseCity.replace(/ /g,"-"); 
      this.createDynamicData('city',cityNoSpace,city);
      if(this.state.locationPagePrompt && this.state.locationPagePrompt.cities && this.state.locationPagePrompt.cities[city] ){    
        let cityPrompt = this.state.locationPagePrompt.cities[city];
        cityPrompt['name'] = `${city},${this.state.state}`;     
        this.setState ( { locationPagePrompt : cityPrompt });
      }
    }
  }

  createDynamicData = (type,data,name) => {
    if( type === LOCATION_TYPE.state ){
      this.setState({
        post_url: `puppies-for-sale-${data}`,
        post_title: `Puppies for Sale in ${data}`,
        post_content: `We have the cutest, most adorable puppies in ${data} to make your family complete`,
        location_hero_title_one : `Puppies for Sale in ${data}`,
        location_hero_image_description : `We have the cutest, most adorable puppies in ${data} to make your family complete`,
        post_meta_title : `Puppies for Sale in ${data} | Meet Your Best Friend Today`,
        post_meta_description : `Find the best puppies for sale in ${data}.`,  
        location_all_puppies_transportation : `${data}`, 
      });  
 
    }else{  
      this.setState({
        post_url: `puppies-for-sale-${data}-${this.state.state}`,
        post_title: `Puppies for Sale in ${data}, ${this.state.state}`,
        post_content: `We have the cutest, most adorable puppies in ${data}, ${this.state.state} to make your family complete`,
        location_hero_title_one: `Puppies for Sale in ${name}, ${this.state.state}`,
        location_hero_image_description : `We have the cutest, most adorable puppies in ${name}, ${this.state.state} to make your family complete`,
        post_meta_title : `Puppies for Sale in ${name} ${this.state.state} | Meet Your Best Friend Today`,
        post_meta_description : `Find the best puppies for sale in ${name} ${this.state.state}.`,      
        location_all_puppies_transportation : `${name}, ${this.state.state}`, 
      });
    }

  }

  changeVal = event => {
    let value = event.target.value;

    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };

  _onChange = (event) => {
   if(event && event.target && event.target.files && event.target.files.length >0 ){
    event.persist();
    this.setState({ imageFile: event.target.files[0] });
   } 
   
  }

  saveHeroImage = async (type) => {
    let _self = this;
    if(this.state.imageFile){
    if(type === IMAGE_TYPE.webp){     
      this.setState({  isHeroWebpImageUploading: true });
    }else{
      this.setState({ isHeroPngImageUploading: true });
    }
    let formData = new FormData();
    formData.append('file', this.state.imageFile);
    let result = await uploadHeroImage(type,formData);
    result.payload.then(resp => {  
      if( type === IMAGE_TYPE.webp ){
      _self.setState({ location_hero_image_webp : resp.data, imageFile : null, isHeroWebpImageUploading : false });
      }else{
        _self.setState({ location_hero_image_png : resp.data, imageFile : null, isHeroPngImageUploading : false  });
      }
      NotificationManager.success("Image Uploaded Successfully");
    });
   }else{
      NotificationManager.warning("Please select image first");
   }

  }

  resetState = () => {
    this.setState(initialState);
  };

  componentWillReceiveProps = (nextProps, prevProps) => {
    if (nextProps.data.wooLocationReducer.addWooLocationPageError && this.props.data.wooLocationReducer.addWooLocationPageError !== nextProps.data.wooLocationReducer.addWooLocationPageError) {
      NotificationManager.error(
        nextProps.data.wooLocationReducer.addWooLocationPageError.details
      );
      this.setState({ loading: false });
    }

    if (nextProps.data.wooLocationReducer.addWooLocationPage && this.props.data.wooLocationReducer.addWooLocationPage !== nextProps.data.wooLocationReducer.addWooLocationPage) {
      NotificationManager.success(
        "Page created successfully"
      );
      setTimeout(() => {
        this.setState({ loading: false });
        this.props.history.push('/location/pages');
      }, 1);
    }

    if(nextProps.data.wooLocationReducer.generatedLocationPageContents && this.props.data.wooLocationReducer.generatedLocationPageContents !== nextProps.data.wooLocationReducer.generatedLocationPageContents){   
      let generatedData = nextProps.data.wooLocationReducer.generatedLocationPageContents;
      this.setState({
        location_all_puppies_title : generatedData.AvailablePuppiesSection ? generatedData.AvailablePuppiesSection.Title : "",
        location_all_puppies_description : generatedData.AvailablePuppiesSection ? generatedData.AvailablePuppiesSection.SubtitleCTA : "",    

        location_quiz_title :  generatedData.AboutTheQuiz ? generatedData.AboutTheQuiz.Title : "",
        location_quiz_description : generatedData.AboutTheQuiz ? generatedData.AboutTheQuiz.SubtitleCTA : "", 

        location_review_title : generatedData.Reviews ? generatedData.Reviews.Title : "",
        location_review_description : generatedData.Reviews ? generatedData.Reviews.SubtitleCTA : "",

        location_finance_title : generatedData.PuppyFinancing ? generatedData.PuppyFinancing.Title : "",
        location_finance_description : generatedData.PuppyFinancing ? generatedData.PuppyFinancing.SubtitleCTA : "", 

        location_delivery_title : generatedData.PuppyDelivery ? generatedData.PuppyDelivery.Title : "",
        location_delivery_description : generatedData.PuppyDelivery ? generatedData.PuppyDelivery.SubtitleCTA : "",

        location_health_commitment_title :  generatedData.PuppyHealthcare ? generatedData.PuppyHealthcare.Title : "" ,
        location_health_commitment_description :  generatedData.PuppyHealthcare ? generatedData.PuppyHealthcare.SubtitleCTA : "",

        location_core_team_title :  generatedData.CoreTeam ? generatedData.CoreTeam.Title : "",
        location_core_team_description :  generatedData.CoreTeam ? generatedData.CoreTeam.SubtitleCTA : "",

        location_contact_title : generatedData.PuppyContactUs ? generatedData.PuppyContactUs.Title : "",
        location_contact_description : generatedData.PuppyContactUs ? generatedData.PuppyContactUs.SubtitleCTA : "",    
        
        isLoadingGeneratedContents : false,
       
        
      });
      NotificationManager.success("Contents are created successfully");
    }

    if(nextProps.data.wooLocationReducer.generatedLocationPageContentsError && this.props.data.wooLocationReducer.generatedLocationPageContentsError !== nextProps.data.wooLocationReducer.generatedLocationPageContentsError){
      this.setState({ isLoadingGeneratedContents : false });
      if(nextProps.suggestedPetsNamesError && nextProps.suggestedPetsNamesError.message){
        NotificationManager.error(nextProps.suggestedPetsNamesError.message); 
      }else{
        NotificationManager.error("An error occurred while generating the contents"); 
      }
    }

  };

  componentDidMount = () => {
    let options = [{ label: "SELECT STATE", value: null }];
    states.map(state => {
      options.push({ label: state.name, value: state.value });
    });

    this.setState({ statesArray: options });
  };

  openConfirmModal = () => {
    $("#confirm_breedersave_modal").modal("show");
  };

  items = [
    { title: "Location Pages", to: "/location/pages" },
    { title: "New Location Page", to: "/location/pages/add" }
  ];

  goBack(self) {
    self.setState({ step: (this.state.step - 1) });
  }

  goNext(self) {    
    if(self.state.state !== "none"){  
      self.setState({ step: (this.state.step + 1) });
    }else{
      NotificationManager.warning("Please select the state");
    }   
  }

  changeBreed = selected => {
    if (!selected || selected.value) {     
      this.setState({ breedId: selected.value, breed : selected.label });
    }
  };

  generateContent = () => {
    if(this.state.state && this.state.state !== 'none' ){
      if(this.state.city){    
        this.props.generateLocationPageContentBaseOnOpenAi(this.state.locationPagePrompt);
      }else{      
        let locationData = this.state.locationPagePrompt;
        delete locationData.cities;  
        this.props.generateLocationPageContentBaseOnOpenAi(locationData); 
      }
     this.setState({ isLoadingGeneratedContents : true });
    }else{
      NotificationManager.warning("Please select the state.");
    }
  }

  render() {
    const {
      state,
      city,
      post_url,
      post_meta_title,
      post_meta_description,
      location_hero_title_one,
      location_hero_title_two,
      location_hero_image_description,
      location_hero_image_webp,
      location_hero_image_png,  
      location_hero_image_alt,
      location_all_puppies_title,
      location_all_puppies_description,
      location_all_puppies_transportation,
      location_quiz_title,
      location_quiz_description,   
      location_review_title,
      location_review_description,   
      location_finance_title,
      location_finance_description, 
      location_delivery_title,
      location_delivery_description,
      location_health_commitment_title,
      location_health_commitment_description,
      location_core_team_title,
      location_core_team_description,
      location_contact_title,
      location_contact_description,
      statesArray,
      citiesArray,
      isHeroWebpImageUploading,
      isHeroPngImageUploading,
      isLoadingGeneratedContents,
      step
    } = this.state;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--lg m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        New Location Page
                        <small>
                          Complete this form to add a new location page
                        </small>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="m-wizard m-wizard--1 m-wizard--success">
                  <div className="m-wizard__form">
                    <form
                      onSubmit={this.submit}
                      className="m-form m-form--label-align-left- m-form--state-"
                    >
                      <div className="m-portlet__body m-portlet__body_grey">
                        <div id={"form-step1"}>
                          <div className="row">
                            <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                              {step === 1 ?
                                <div className="m-form__section">                                              
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Select State:
                                    </label>
                                    <div className="col-lg-6">                        
                                      <Select
                                        options={statesArray}
                                        value={state}
                                        name="state"
                                        onChange={this.changeState}
                                        placeholder="Select the Timeline"
                                      />
                                      <span>
                                        Select the state
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Select City:
                                    </label>
                                    <div className="col-lg-6">                                
                                      <Select
                                        options={citiesArray}
                                        value={city}
                                        name="city"
                                        onChange={this.changeCity}
                                        placeholder="Select the Timeline"
                                      />
                                      <span>
                                        Select the city
                                      </span>
                                    </div>
                                  </div>
                                  <div className="row">                                
                                    <div className="col-10"> 
                                    <div className="row justify-content-end">
                                      <div>
                                    { !isLoadingGeneratedContents ?                                
                                     <button
                                       className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill btn-sm"
                                       onClick={(e)=>{ this.generateContent()}}
                                    >
                                      Create Contents
                                    </button>:
                                     <div className="center-row">
                                        <Loader size={25} />
                                      </div>   
                                    }
                                    </div>
                                    </div>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      URL:
                                    </label>
                                    <div className="col-lg-6">
                                      <span>
                                       {config.wooConfig.siteUrl}/{post_url}
                                                                            
                                    </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Meta Title:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={post_meta_title}
                                        name="post_meta_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span>
                                        Enter meta title 
                                      </span>
                                    </div>
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Meta Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="post_meta_description"
                                        onChange={this.changeVal}
                                        value={post_meta_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div>                      
                                                 
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                     Hero Image Title One:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_hero_title_one}
                                        name="location_hero_title_one"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                      >
                                        Enter the hero image title one
                                      </span>
                                    </div>                                 
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                     Hero Image Title Two:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_hero_title_two}
                                        name="location_hero_title_two"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                      >
                                        Enter the hero image title two
                                      </span>
                                    </div>                                 
                                  </div>
                          
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                     Hero Image Description:
                                    </label>
                                    <div className="col-lg-6">

                                      <textarea
                                        className="form-control m-input"
                                        name="location_hero_image_description"
                                        onChange={this.changeVal}
                                        value={location_hero_image_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div> 
                         
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                     Upload WebP Hero Image:
                                    </label>
                                    <div className="col-lg-4">
                                    <input 
                                      ref="file"
                                      type="file"
                                      accept="image/*" 
                                      name="imgSrc"
                                      onChange={this._onChange}
                                      
                                    />                             
                                    </div>
                                    <div className="col-lg-2">                       
                                     
                                      <a
                                       className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                       onClick={() => this.saveHeroImage('webp')}    
                                      >
                                         <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
                                      </a>
                                    </div>
                                    { isHeroWebpImageUploading ?                                    
                                    <div className="col-lg-2">
                                      <div className="center-row">                                         
                                          <Loader size={25} />
                                      </div>
                                    </div>:null
                                    }
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      WebP Hero Image:
                                    </label>
                                    <div className="col-lg-6">                                
                                      <input
                                        type="text"
                                        value={location_hero_image_webp}
                                        name="location_hero_image_webp"                                   
                                        className="form-control m-input"
                                        disabled
                                      />                                
                                    </div>
                           
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Upload PNG Hero Image:
                                    </label>
                                    <div className="col-lg-4">
                                    <input 
                                      ref="file"
                                      type="file"
                                      accept="image/*" 
                                      name="imgSrc"
                                      onChange={this._onChange}
                                      
                                    />                             
                                    </div>
                                    <div className="col-lg-2">                                      
                                      <a
                                       className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                       onClick={() => this.saveHeroImage('png')}    
                                      >
                                         <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
                                      </a>
                                    </div>
                                    { isHeroPngImageUploading ?
                                    <div className="col-lg-2">
                                      <div className="center-row">                                         
                                          <Loader size={25} />
                                      </div>
                                    </div>:null
                                    }
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      PNG Hero Image:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_hero_image_png}
                                        name="location_hero_image_png"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        disabled
                                      />                                 
                                    </div>
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Hero Image Alt text:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_hero_image_alt}
                                        name="location_hero_image_alt"
                                        onChange={this.changeVal}
                                        className="form-control m-input"                                
                                      />                                 
                                    </div>
                                  </div>

                              
                                </div>
                                : ""}
                              {step === 2 ?
                                <div className="m-form__section">
                                  <h1>Available Puppies Section</h1>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_all_puppies_title}
                                        name="location_all_puppies_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                      >
                                        Enter available puppies section title
                                      </span>
                                    </div>
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_all_puppies_description"
                                        onChange={this.changeVal}
                                        value={location_all_puppies_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div>
                          
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Transportation city text:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_all_puppies_transportation"
                                        onChange={this.changeVal}
                                        value={location_all_puppies_transportation}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div>
                                </div>
                                : ""}

                              {step === 3 ?
                                <div className="m-form__section">
                                  <h1>About The Quiz</h1>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_quiz_title}
                                        name="location_quiz_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span>
                                        Enter the quiz title
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_quiz_description"
                                        onChange={this.changeVal}
                                        value={location_quiz_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div>                        
                                </div>
                                : ""}

                              {step === 4 ?
                                <>
                                  <div className="m-form__section">
                                    <h1>Reviews</h1>
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-4 col-form-label">
                                        Title:
                                      </label>
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          value={location_review_title}
                                          name="location_review_title"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                        />
                                        <span>
                                          Enter the title
                                        </span>
                                      </div>
                                    </div>
                                    <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_review_description"
                                        onChange={this.changeVal}
                                        value={location_review_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                    </div>                                     
                                  </div>                 
                                </>
                                : ""} 

                              {step === 5 ?
                                <div className="m-form__section">
                                  <h1>Puppy Financing</h1>                    
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_finance_title}
                                        name="location_finance_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span>
                                        Enter the title
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_finance_description"
                                        onChange={this.changeVal}
                                        value={location_finance_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div>
                                </div>
                                : ""}

                              {step === 6 ?
                                <div className="m-form__section">
                                  <h1>Puppy Delivery</h1>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_delivery_title}
                                        name="location_delivery_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span>
                                        Enter the title
                                      </span>
                                    </div>
                                  </div>                   
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_delivery_description"
                                        onChange={this.changeVal}
                                        value={location_delivery_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div>
                                </div>
                                : ""}

                             {step === 7 ?
                                <div className="m-form__section">
                                  <h1>Health Commitment</h1>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_health_commitment_title}
                                        name="location_health_commitment_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                      >
                                        Enter the title
                                      </span>
                                    </div>
                                  </div>                        
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_health_commitment_description"
                                        onChange={this.changeVal}
                                        value={location_health_commitment_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div>                               
                                 </div>
                                : ""}

                              {step === 8 ?
                                <div className="m-form__section">
                                  <h1>Core Team</h1>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                       Title:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_core_team_title}
                                        name="location_core_team_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span>
                                        Enter the title
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_core_team_description"
                                        onChange={this.changeVal}
                                        value={location_core_team_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div>
                                </div>
                                : ""}

                              {step === 9 ?
                                <div className="m-form__section">
                                  <h1>Puppy Contact Us</h1>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Title:
                                    </label>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        value={location_contact_title}
                                        name="location_contact_title"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span>
                                        Enter the title
                                      </span>
                                    </div>
                                  </div> 

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Description:
                                    </label>
                                    <div className="col-lg-6">
                                      <textarea
                                        className="form-control m-input"
                                        name="location_contact_description"
                                        onChange={this.changeVal}
                                        value={location_contact_description}
                                        id="exampleTextarea"
                                        rows="5"
                                      ></textarea>
                                    </div>
                                  </div>                           
                                </div>
                                : ""}

                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="m-portlet__foot">
                        <div className="row">
                          <div className="col-lg-12">
                            {this.state.loading == false ? (
                              <div
                                className="row"
                                style={{ justifyContent: "flex-end" }}
                              >
                                <div>
                                  {step > 1 ?
                                    <button
                                      type="button"
                                      onClick={e => this.goBack(this)}                               
                                      className="btn btn-secondary m-btn--pill mx-2 mt-2"
                                     >
                                      <span>
                                        <span>Back</span>
                                      </span>
                                    </button>
                                    : ""}
                                  {step === 9 ?
                                    <button
                                      type="button"
                                      onClick={this.newPageCreate}                                  
                                      className="btn btn-primary m-btn--pill mx-2 mt-2"
                                    >
                                      <span>
                                        &nbsp;&nbsp;
                                        <span>Add New Page</span>
                                        &nbsp;&nbsp;                                      
                                      </span>
                                    </button>
                                    :
                                    <button
                                      type="button"
                                      onClick={e => this.goNext(this)}                                
                                      className="btn btn-secondary m-btn--pill mx-2 mt-2"
                                    >
                                      <span>
                                        <span>Next</span>
                                      </span>
                                    </button>
                                  }
                                </div>

                              </div>
                            ) : (
                              <div className="center-row">
                                <Loader size={50} />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state,
});

const mapDispatchToProps = dispatch => ({
  createWooLocationPage: (data) => {
    dispatch(createWooLocationPage(data));
  },
  uploadHeroImage: (data) => {
    dispatch(uploadHeroImage(data))
  },
  generateLocationPageContentBaseOnOpenAi : (data) => {
    dispatch(generateLocationPageContentBaseOnOpenAi(data));
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Datamodal)
);